<template>
  <div>
    <TenantHeader />

    <div class="tenant-valid-body">
      <h2 class="tenant-title">
        Olá, <span class="primary">{{ initialLesseName }}</span>
      </h2>

      <p class="body-regular gray-700">
        Você teve o crédito aprovado para o pagamento do título de capitalização
        junto à Icatu, através do Parcelex.
        <br/>
        <br/>
        Isso quer dizer que você pode parcelar o título de capitalização em até
        24 vezes no boleto, com entrada mínima de {{
          firstDownPaymentOption.downPaymentPercentage
        }}%
        e juros a partir de {{ interest | interestRateFilter }} a.m.
        <br/>
        <br/>
        Continue para ver as opções de parcelamento disponíveis para você.
      </p>

      <div class="tenant-valid-info only-on-large">
        <div class="tenant">
          <p class="info-title">Locatário</p>
          <p class="info-value">{{ proposal.lesseeName }}</p>
        </div>
        <div class="address">
          <p class="info-title">Endereço do imóvel</p>
          <p class="info-value">
            {{ proposal.addressStreet }}, {{ proposal.addressNumber }}
            <br/>
            {{ proposal.zipCode | zipCodeFilter }}
            <br/>
            {{ proposal.city }}/{{ proposal.state }}
          </p>
        </div>
        <div class="cpf">
          <p class="info-title">CPF</p>
          <p class="info-value">{{ proposal.lesseeCpf | cpfFilter }}</p>
        </div>
      </div>

      <div class="tenant-btn">
        <Button
          class="primary"
          @click="() => this.$router.push('/locatario/opcoes')"
        >
          Ver opções de parcelamento
        </Button>
      </div>

    </div>
  </div>
</template>

<script>
import Button from '@/components/ui/AppButton.vue';
import TenantHeader from './TenantHeader.vue';
import stringMixin from '../../../mixins/string';

export default {
  name: 'tenantValid',
  metaInfo: {
    title: 'Proposta Aprovada',
  },
  components: {
    TenantHeader,
    Button,
  },
  mixins: [stringMixin],
  props: {
    proposal: {
      type: Object,
      required: true,
    },
  },
  computed: {
    interest() {
      if (!this.proposal) {
        return null;
      }
      const lastOption = this.proposal.downPaymentOptions[0].options.length - 1;
      return this.proposal.downPaymentOptions[0].options[lastOption].interestRatePM;
    },
    firstDownPaymentOption() {
      return this.proposal && this.proposal.downPaymentOptions[0];
    },
    initialLesseName() {
      return this.proposal?.lesseeName ? this.proposal?.lesseeName.split(' ')[0] : '';
    },
  },
};
</script>

<style lang="scss" scoped>
  .tenant-valid-header {
    img {
      width: 150px;
      height: 32px;
    }
  }

  //mobile 100%
  .tenant-valid-body {
    /* width: 83.33%; */
  }

  .tenant-title {
    margin: 24px 0 16px 0;
  }

  .tenant-valid-info {
    margin: 16px 0 24px 0;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 20px;
    grid-template-areas:
      "tenant tenant . address address ."
      "cpf cpf . address address .";
  }

  .info-title {
    @extend .body-bold;
    color: var(--gray-700);
    margin-bottom: 4px;
  }

  .info-value {
    @extend .body-regular;
    color: var(--gray-700);
  }

  .tenant {
    grid-area: tenant;
  }

  .address {
    grid-area: address;
  }

  .cpf {
    grid-area: cpf;
  }

  @media (max-width: $breakpoint-large) {
    .tenant-valid-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .tenant-btn {
      position: fixed;
      bottom: 0;
      left: 0;
      padding: 24px;
      width: 100%;

      button {
        height: 48px;
        width: calc(100% - 48px);
      }
    }
  }

</style>
